/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* Librairies */
import React from 'react';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';

/* Components */
import Async from '../../../Async';
import Loader from '../../../Loader';
import GeolocIcon from '../../../../svg/utils/geoloc';

/* Utils */
import { DEFAULT_RADIUS } from '../../../../shared/googlemap/constantes';
import { canIGeoloc, getGeolocCookie, initGoogleMapScript,
  getPlaceIdFromCoords, getPlaceDetails } from '../../../../shared/googlemap';
import Tooltip, { hideAll } from '../../../Tooltip';
import env from '../../../../shared/env';

/* Styles */
import t from '../../../../css/global.module.css';
import s from './geoLoc.module.css';


const ALIGN = { points: ['tc', 'tc'], overflow: { adjustX: 0, adjustY: 0 }, targetOffset: ['110px', '-45px'] };

class Geoloc extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      geolocOn: false,
      modalGeolocIsOpen: false,
      allowNavigatorGeoloc: false,
      locationInfo: { locality: null, radius: DEFAULT_RADIUS },
      // eslint-disable-next-line react/no-unused-state
      previousLocationInfo: {},
      tooltipLocation: false,
      delayHideTooltip: 0,
      loading: false,
    };

    this.setAutoGeoloc = this.setAutoGeoloc.bind(this);
    this.setLocalization = this.setLocalization.bind(this);
    this.saveLocation = this.saveLocation.bind(this);
    this.cancelModalGeoloc = this.cancelModalGeoloc.bind(this);
    this.openModalGeoloc = this.openModalGeoloc.bind(this);
    this.updateLocationInfo = this.updateLocationInfo.bind(this);
    this.disableLocalization = this.disableLocalization.bind(this);
    this.enableLocalization = this.enableLocalization.bind(this);
    this.toggleLocalization = this.toggleLocalization.bind(this);
    this.toggleGeolocButton = this.toggleGeolocButton.bind(this);
  }

  componentWillMount() {
  }

  componentDidMount() {
    // componentWillMount is called on server rendering,
    // therefore this is the only place to call it.
    /* eslint-disable react/no-did-mount-set-state */
    this.setState({ loading: true });
    getGeolocCookie()
      .then((res) => {
        if (res.locality && res.geocode) {
          const locationInfo = {
            locality: res.locality,
            radius: res.radius,
          };
          this.toggleGeolocButton(false);
          return this.setState({ locationInfo });
        }
        return this.setState({ loading: false });
      })
      .catch(() => (
        this.setState({ loading: false })
      ));
  }

  setAutoGeoloc(res) {
    this.setState({ allowNavigatorGeoloc: true });
    initGoogleMapScript(() => {
      const coords = { lat: res.coords.latitude, lng: res.coords.longitude };
      getPlaceIdFromCoords(coords)
        .then((placeid) => {
          getPlaceDetails(placeid)
            .then((details) => {
              const locationInfo = {
                locality: details.locality,
                geocode: coords,
              };
              this.saveLocation(locationInfo);
            });
        })
        .catch((err) => {
          console.error(err.message);
        });
    });
    return this.setState({ loading: false });
  }

  setLocalization() {
    canIGeoloc()
      .then((res) => {
        this.setAutoGeoloc(res);
      })
      .catch((err) => {
        console.error(err.message);
        this.setState({ allowNavigatorGeoloc: false, loading: false });
        this.openModalGeoloc();
      });
  }

  getParamGeolocActive() {
    return {
      geolocOn: this.state.geolocOn,
      locationInfo: this.state.locationInfo,
      labelSet: this.props.labels.tooltip.set,
      onOpenModal: this.openModalGeoloc,
      link: this.props.labels.tooltip.link,
    };
  }

  getParamGeolocInactive() {
    return {
      labelUnset: this.props.labels.tooltip.unset,
    };
  }

  geoLocCaption() {
    const color = this.state.geolocOn ? '#000000' : '#828282';
    return (
      <div className={`${t.flex} ${t['items-center']} ${t.pointer} ${s.location}`} onClick={this.toggleLocalization} data-qa="geolocButton">
        { this.state.loading
          && (
            <span className={s.loader}>
              <Loader size={1.5} fill={color} />
            </span>
          )
        }
        { !this.state.loading
          && (
            <span className={s.iconGeoloc}>
              <GeolocIcon fill={color} />
            </span>
          )
        }
        <span className={`${t['helper_hide-BelowDesktop']} ${t.gray} ${s.txtGeoloc}`}>
          {this.props.labels.main}
        </span>
      </div>
    );
  }

  toggleLocalization() {
    /*
     Tooltip must be displayed as soon the user click on it,
     but must still to screen if user have previously triggered the modal
     */
    this.setState({
      tooltipLocation: !env.isTouchable(),
      delayHideTooltip: 0,
      loading: true,
    });
    if (this.state.geolocOn) {
      return this.disableLocalization();
    }
    return this.enableLocalization();
  }

  enableLocalization() {
    return getGeolocCookie()
      .then(() => {
        this.toggleGeolocButton(true);
      })
      .catch(() => {
        this.setLocalization();
      });
  }

  disableLocalization() {
    return this.toggleGeolocButton(false);
  }

  updateLocationInfo(newLocationInfo) {
    this.setState({ locationInfo: newLocationInfo });
  }

  /* TooltipLocation is set to true because
   tooltip containing new geoloc settings is displayed by default
   */
  saveLocation(newLocationInfo = {}) {
    if (newLocationInfo.locality && newLocationInfo.geocode) {
      this.toggleGeolocButton(true);
      const { locationInfo } = this.state;
      return this.setState({
        modalGeolocIsOpen: false,
        locationInfo: Object.assign({}, locationInfo, newLocationInfo),
        tooltipLocation: true,
        delayHideTooltip: 5000,
      });
    }
    return this.cancelModalGeoloc();
  }

  openModalGeoloc() {
    const { locationInfo } = this.state;
    const clonedLocation = cloneDeep(locationInfo);
    // eslint-disable-next-line react/no-unused-state
    this.setState({ modalGeolocIsOpen: true, previousLocationInfo: clonedLocation });
  }

  cancelModalGeoloc() {
    const { locationInfo } = this.state;
    // eslint-disable-next-line react/no-unused-state
    this.setState({ locationInfo, previousLocationInfo: {}, modalGeolocIsOpen: false });
    hideAll();
  }

  toggleGeolocButton(turnOn) {
    this.setState({ geolocOn: turnOn, loading: false });
    this.props.updateGlobalGeolocState(turnOn);
  }

  renderTooltip(geolocInactive, geolocActive) {
    const label = (<div>{ this.geoLocCaption() }</div>);
    if (this.state.modalGeolocIsOpen) {
      return label;
    }

    return (
      <div className={`${t['items-center']} ${t['bg-left']}`}>
        <Tooltip
          content={() => (
            <Async
              promise={
                import(
                  /* webpackChunkName: "TooltipGeoloc" */
                  /* webpackMode: "lazy" */
                  // eslint-disable-next-line function-paren-newline
                  './components/TooltipGeoloc')
              }
              geolocInactive={geolocInactive}
              geolocActive={geolocActive}
            />
          )}
          event="hover"
          customClassName={s.tooltipGeoloc}
          defaultVisible={this.state.tooltipLocation}
          delayHide={this.state.delayHideTooltip}
          align={ALIGN}
        >
          {label}
        </Tooltip>
      </div>
    );
  }

  render() {
    /* Set labels - END */
    /* Set conditional classes - START */
    /* Set conditional classes - END */
    return (
      <div>
        <div data-to="replace" />
        {this.state.geolocOn && this.state.locationInfo.locality
          && this.renderTooltip(null, this.getParamGeolocActive())
        }
        {!this.state.geolocOn
          && this.renderTooltip(this.getParamGeolocInactive(), null)
        }
        {this.state.modalGeolocIsOpen
          && (
            <Async
              promise={
                import(
                  /* webpackChunkName: "ModalGeoloc" */
                  /* webpackMode: "lazy" */
                  // eslint-disable-next-line function-paren-newline
                  './components/ModalGeolocCtn')
              }
              labels={this.props.labels.modal}
              mapId="geolocMapCtn"
              modalGeolocIsOpen={this.state.modalGeolocIsOpen}
              location={this.state.locationInfo}
              allowNavigatorGeoloc={this.state.allowNavigatorGeoloc}
              onRequestClose={this.cancelModalGeoloc}
              onValidateModal={this.saveLocation}
            />
          )
        }
      </div>
    );
  }
}

Geoloc.propTypes = {
  labels: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ])),
  updateGlobalGeolocState: PropTypes.func.isRequired,
};

Geoloc.defaultProps = {
  labels: {},
};

export default Geoloc;
